module.exports = __webpack_public_path__ + "img/caiji-youshi-1-1.d526625f.png";